import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api'
import React from 'react'
import { useSelector } from 'react-redux'

export const JustMap = () => {
  const { isLoaded } = useJsApiLoader({ 
    googleMapsApiKey: process.env.REACT_APP_MAPS_API_KEY
  })
  const { trackingOrder } = useSelector(state => state.order)
  const { account } = trackingOrder
  !isLoaded &&  <h3>Loading...</h3>
  return <Map coors={{ lat: account.latitude, lng: account.longitude }}/>
}


const Map = ({coors}) => {
  return (
    <GoogleMap
      zoom={10}
      center={coors}
    >
      <Marker position={coors}/>
    </GoogleMap>
  )
  
}